<template>
  <div class="warp">
     <Home></Home>
     <brand></brand>
     <product></product>
     <supply></supply>
     <team></team>
     <enter></enter>
  </div>
</template>
<script>
// 首页
import Home from './components/home.vue'
// 品牌优势
import brand from './components/brand.vue'
// 产品优势
import product from './components/product.vue'
// 供应链优势
import supply from "./components/supply.vue"
// 团队优势
import team from "./components/team.vue"
// 立即入驻
import enter from './components/enter.vue'
export default {
 name: 'Login',
 components:{
     product,
     Home,
     supply,
     brand,
     team,
     enter
 },
 data:()=>({

 }),
 created(){

 },
 mounted(){
  this.$parent.setBtnList(['merchant'])
  window.scrollTo(100,0);
 },
 beforeDestroy(){
  this.$parent.setBtnList([])
 },
 methods:{
 }
}
</script>
<style scoped>
</style>